import type { ICsfApiPort } from '@subscriptions/application/ports';
import type { CsfDataViewDto } from '@subscriptions/application/dtos';
import type { CsfHttpClientType } from '@subscriptions/infrastructure/api';
import type { CsfApiMapperType } from '@subscriptions/infrastructure/mappers/CsfApiMapper';

/**
 * Implementation of ICsfApiPort against parrot-onboarding-api.
 *
 * @param props.httpClient - CSF HTTP client
 * @param props.mapper - CSF API mapper
 */
export const createCsfApiRepository = (props: {
  httpClient: CsfHttpClientType;
  mapper: CsfApiMapperType;
}): ICsfApiPort => {
  const { httpClient, mapper } = props;

  const extract = async (file: File): Promise<CsfDataViewDto> => {
    const response = await httpClient.extract(file);
    return mapper.mapApiResponseToDto(response);
  };

  return { extract };
};
